import { Image } from "@heroui/react";

export function ActionScreen({
  image,
  imageAlt,
  paragraphOne,
  title,
}: {
  image: string;
  imageAlt: string;
  paragraphOne?: string;
  title: string;
}) {
  return (
    <div className="flex flex-1 items-center justify-center">
      <div className="flex max-w-4xl flex-col items-center gap-4 text-gray-900 tablet:h-[200px] tablet:flex-row tablet:items-center tablet:gap-8">
        <div className="flex flex-col p-4 tablet:h-full tablet:justify-center">
          <h1 className="text-heading-xxl font-bold">{title}</h1>
          {paragraphOne && <p className="mt-6 text-body-lg">{paragraphOne}</p>}
        </div>
        <Image
          alt={imageAlt}
          className="h-[160px] overflow-visible p-4 tablet:h-[200px] tablet:flex-shrink-0"
          src={image}
        />
      </div>
    </div>
  );
}
